import { getSubscriptionPlanKey, getSubscriptionTier, isAnnualSubscriptionPlan, } from '../subscriptions/SubscriptionTier';
const allowedEvaluateTags = [
    'guest',
    'signedIn',
    'isSubscribed',
    'subscribed',
    'subscribedBasic',
    'subscribedBasicAnnual',
    'subscribedBusiness',
    'subscribedPremium',
    'subscribedPremiumAnnual',
    'freeMeal',
    'mobileApp',
    'mobileWeb',
    'desktopWeb',
    'kiosk',
    'drivePlus',
    'showSunsetPointsInfo',
    'defaultProductCatalog',
    'home',
    'isCartPage',
    'subscriptionPlans',
    'pendingOrder',
    'productCatalog',
    'landingPageMobile',
    'androidApp',
    'iOSApp',
    'landingPageKiosk',
    'userProfilePointsRN',
    'landingPageRN',
    'basketPageRN',
    'loginScreenRN',
    'guestRN'
];
const allowedEvaluateTagSet = new Set(allowedEvaluateTags);
const RESERVED_WORDS = new Set([
    'arguments', 'await', 'break', 'case', 'catch', 'class', 'const', 'continue', 'debugger', 'default',
    'delete', 'do', 'else', 'enum', 'eval', 'export', 'extends', 'false', 'finally', 'for', 'function',
    'if', 'implements', 'import', 'in', 'instanceof', 'interface', 'let', 'new', 'null', 'package',
    'private', 'protected', 'public', 'return', 'static', 'super', 'switch', 'this', 'throw', 'true',
    'try', 'typeof', 'undefined', 'var', 'void', 'while', 'with', 'yield'
]);
const globalScope = typeof globalThis !== 'undefined' ? globalThis : new Function('return this')();
const findUnknownEvaluateTags = (expression) => {
    var _a;
    const withoutComments = expression.replace(/\/\/[^\n]*|\/\*[\s\S]*?\*\//g, ' ');
    const withoutStrings = withoutComments.replace(/(['"`])(?:\\.|(?!\1).)*\1/g, ' ');
    const identifiers = ((_a = withoutStrings.match(/\.?[A-Za-z_$][\w$]*/g)) !== null && _a !== void 0 ? _a : []).filter((identifier) => !identifier.startsWith('.'));
    return identifiers.filter((identifier, index) => identifiers.indexOf(identifier) === index &&
        !allowedEvaluateTagSet.has(identifier) &&
        !RESERVED_WORDS.has(identifier) &&
        !(identifier in globalScope));
};
const generateExpression = (evaluatedTags, expressionTags, options = {}) => {
    const expression = expressionTags !== null && expressionTags !== void 0 ? expressionTags : '';
    const unknownTags = findUnknownEvaluateTags(expression);
    if (options.strict && unknownTags.length > 0) {
        throw new ReferenceError(`Unknown target group tags: ${unknownTags.join(', ')}`);
    }
    const parameterNames = [...allowedEvaluateTags, ...unknownTags];
    const allowedTagValues = {};
    allowedEvaluateTags.forEach((tag) => {
        allowedTagValues[tag] = evaluatedTags[tag];
    });
    const generateFunction = new Function(`{ ${parameterNames.join(', ')} }`, expression);
    return Boolean(generateFunction(allowedTagValues));
};
const generateEvaluateTags = (data) => {
    var _a;
    const planKey = getSubscriptionPlanKey(data.subscriptionType);
    const tier = getSubscriptionTier(data.subscriptionType);
    const isAnnual = isAnnualSubscriptionPlan(data.subscriptionType);
    const isEmployee = tier === 'employee';
    return Object.assign(Object.assign({ guest: !(data.userData && data.userData.token), signedIn: Boolean(data.userData && data.userData.token), mobileApp: data.channel === 'mobileApp', mobileWeb: data.channel === 'mobileBrowser', desktopWeb: data.channel === 'desktopBrowser', kiosk: data.channel === 'kiosk', drivePlus: data.channel === 'drivePlus', defaultProductCatalog: data.page === 'defaultProductCatalog', isSubscribed: !isEmployee && Boolean(data.subscriptionType), subscribed: !isEmployee && (Boolean(data.OTP) || Boolean(data.subscriptionType)), freeMeal: Boolean(data.subscriptionType) && Boolean(data.hasFreeMeal), isEmployee, subscribedBasic: planKey === 'Basic' || (tier === 'basic' && !isAnnual), subscribedBasicAnnual: planKey === 'BasicAnnual' || (tier === 'basic' && isAnnual), subscribedPremium: planKey === 'Premium' || (tier === 'premium' && !isAnnual), subscribedPremiumAnnual: planKey === 'PremiumAnnual' || (tier === 'premium' && isAnnual), subscribedBusiness: planKey === 'Business' || tier === 'business' }, ('showSunsetPointsInfo' in data ? { showSunsetPointsInfo: data.showSunsetPointsInfo } : null)), { home: data.page === 'home', isCartPage: data.page === 'cart', landingPageKiosk: data.page === 'landingpagekiosk', subscriptionPlans: data.page === 'subscriptionPlans', pendingOrder: !!data.page && data.page.toLowerCase() === 'pendingorder', productCatalog: !!data.page && data.page.toLowerCase() === 'productcatalog', landingPageMobile: !!data.page && data.page.toLowerCase() === 'landingpagemobile', androidApp: data.platform === 'android', iOSApp: data.platform === 'ios', userProfilePointsRN: data.segment === '/(tabs)/user-profile', landingPageRN: data.segment === '/(tabs)/(home)', basketPageRN: data.segment === '/catalog/basket', loginScreenRN: data.segment === '/(auth)/welcome', guestRN: (_a = data.guestRN) !== null && _a !== void 0 ? _a : false });
};
export { generateExpression, generateEvaluateTags, allowedEvaluateTags };
